<app-form-screenbsk
    [tagList]="tagList"
    [basketList]="basketList"
    (onValidate)="validate($event)"
    (onCancel)="cancel()">
</app-form-screenbsk>
